import { render } from "./AssistantWidgetBlock.vue?vue&type=template&id=8638dae2&scoped=true"
import script from "./AssistantWidgetBlock.vue?vue&type=script&lang=js"
export * from "./AssistantWidgetBlock.vue?vue&type=script&lang=js"

import "./AssistantWidgetBlock.vue?vue&type=style&index=0&id=8638dae2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8638dae2"]])

export default __exports__